import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    components: {
      headlines: false,
      releases: false,
      ravecast: false,
      post: false
    }
  },
  mutations: {
    setLoading (state, payload) {
      state.components[payload.variable] = payload.value
    }
  },
  actions: {
    setLoading (context, payload) {
      context.commit('setLoading', payload)
    }
  },
  getters: {
    getLoading (state) {
      return state.components
    }
  }
})
